/*
 * İçindekiler arşivi — mod değiştirme, geçmiş yönetimi ve yakınlaştırma.
 *
 * Tüm sayılar sunucu tarafında basılıdır; buradaki iş yalnızca hangisinin
 * görüneceğini değiştirmek ve URL'i buna göre güncellemektir. Sunucudan veri
 * çekilmez, istemcide şablon üretilmez.
 */
(function () {
  'use strict';

  var PARAM = 'ay';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function slugFromUrl() {
    return new URLSearchParams(window.location.search).get(PARAM);
  }

  /* ------------------------------------------------------ yakınlaştırma */

  var zoom = null;

  function buildZoom() {
    if (zoom) return zoom;

    var overlay = document.createElement('div');
    overlay.className = 'yip-icindekiler-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Sayfa görüntüleyici');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'yip-icindekiler-zoom__close';
    close.setAttribute('aria-label', 'Kapat');
    close.innerHTML = '&times;';

    var img = document.createElement('img');
    img.className = 'yip-icindekiler-zoom__img';
    img.alt = '';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'yip-icindekiler-zoom__toggle';
    toggle.textContent = 'Yakınlaştır';

    overlay.appendChild(close);
    overlay.appendChild(img);
    overlay.appendChild(toggle);
    document.body.appendChild(overlay);

    zoom = { overlay: overlay, img: img, close: close, toggle: toggle, trigger: null };

    /* Yakınlaştırma genişliği: kaynağın kendi çözünürlüğü, ama EN AZ ekranın
       iki katı.
       Neden alt sınır var: taramalar ~1209px genişliğinde, masaüstü katmanı
       ise ~1400px+. Yalnızca naturalWidth kullanılsaydı "yakınlaştırma"
       görseli KÜÇÜLTÜRDÜ. A4 sayfasında amaç metni okumak olduğu için,
       kaynak dar olsa bile büyütmek doğru davranış — bedeli bir miktar
       yumuşama. */
    function zoomWidth() {
      return Math.max(img.naturalWidth, Math.round(overlay.clientWidth * 2));
    }

    function setZoomed(on) {
      if (on) {
        overlay.classList.add('is-zoomed');
        img.style.width = zoomWidth() + 'px';
        toggle.textContent = 'Uzaklaştır';
        // Yakınlaştırınca yatayda ortala
        overlay.scrollLeft = (zoomWidth() - overlay.clientWidth) / 2;
      } else {
        overlay.classList.remove('is-zoomed');
        img.style.width = '';
        toggle.textContent = 'Yakınlaştır';
        overlay.scrollLeft = 0;
      }
    }

    function toggleZoomed() {
      setZoomed(!overlay.classList.contains('is-zoomed'));
    }

    /* Ayrı bir fonksiyon: aynı görsel tekrar açıldığında src değişmediği
       için `load` YENİDEN TETİKLENMEZ; o durumda openZoom bunu elle çağırır.

       Eskiden burada "kaynak ekrandan genişse yakınlaştır, değilse butonu
       gizle" kuralı vardı. Taramalar (~1209px) masaüstü katmanından (~1400px+)
       dar oldugu icin kural HER ZAMAN olumsuz sonuclanıyordu: buton hiç
       görünmüyor, imleç değişmiyor ve görsele tıklamak hiçbir şey yapmıyordu.
       Yakınlaştırma artık koşulsuz açık. */
    function measure() {
      toggle.hidden = false;
      setZoomed(false);
    }

    img.addEventListener('load', measure);
    zoom.measure = measure;

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      toggleZoomed();
    });

    close.addEventListener('click', function (event) {
      event.stopPropagation();
      closeZoom();
    });

    /* MASAÜSTÜ: katmanın açık olması zaten "yakınlaştırılmış" hâl; görsele
       tıklamak kapatır (X ile aynı sonuç).

       DOKUNMATİK: görsele dokunmak HİÇBİR ŞEY YAPMAZ. Sebep: büyütülmüş bir
       sayfada gezinmek için parmakla sürüklemek gerekiyor ve görselin
       üzerinde biten bir sürükleme, dokunuştan ayırt edilemiyor — okurken
       kazara kapanıyordu. Kapatmak için X ya da çevresindeki koyu boşluk.

       Butonlar kendi dinleyicilerinde stopPropagation yaptığı için buraya
       ulaşmaz. */
    var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

    overlay.addEventListener('click', function (event) {
      if (coarsePointer && event.target === img) return;
      closeZoom();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) closeZoom();
    });

    zoom.setZoomed = setZoomed;
    return zoom;
  }

  function openZoom(pageImg) {
    var z = buildZoom();
    z.trigger = pageImg;

    // src, image_url: width: 2000 ile üretilen en yüksek çözünürlüktür
    // (Shopify kaynağın üstüne çıkmaz). currentSrc srcset'ten daha küçük bir
    // sürüm seçmiş olabileceği için bilerek src kullanıyoruz.
    var nextSrc = pageImg.getAttribute('src');
    var sameImage = z.img.getAttribute('src') === nextSrc;
    z.img.src = nextSrc;
    z.img.alt = pageImg.getAttribute('alt') || '';
    z.overlay.classList.add('is-open');
    document.body.classList.add('yip-icindekiler-zoom-open');
    z.close.focus();

    /* Aynı görsel yeniden açıldıysa src değişmediği için `load` tetiklenmez
       ve ölçüm/sıfırlama hiç çalışmazdı: görsel bir önceki seferden kalma
       yakınlaştırılmış hâliyle açılıyordu. Elle çağırıyoruz. */
    if (sameImage && z.img.complete) z.measure();
  }

  function closeZoom() {
    if (!zoom) return;
    zoom.overlay.classList.remove('is-open');
    zoom.setZoomed(false);
    document.body.classList.remove('yip-icindekiler-zoom-open');
    if (zoom.trigger) {
      zoom.trigger.focus({ preventScroll: true });
      zoom.trigger = null;
    }
  }

  /* --------------------------------------------------------- bölüm kurulumu */

  function initRoot(root) {
    if (root.getAttribute('data-yip-ready')) return;
    root.setAttribute('data-yip-ready', '1');

    var base = root.getAttribute('data-yip-base') || window.location.pathname;
    var list = root.querySelector('[data-yip-list]');
    var journals = toArray(root.querySelectorAll('[data-yip-journal]'));

    function apply(slug) {
      var match = null;

      journals.forEach(function (journal) {
        var isMatch = slug && journal.getAttribute('data-yip-journal') === slug;
        journal.hidden = !isMatch;
        if (isMatch) match = journal;
      });

      // Bilinmeyen ya da silinmiş slug -> boş sayfa yerine listeye düş
      if (list) list.hidden = !!match;
      return match;
    }

    root.addEventListener('click', function (event) {
      // Yeni sekmede açma / orta tık gibi davranışları bozma
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      var page = event.target.closest('.yip-icindekiler__page');
      if (page && root.contains(page)) {
        event.preventDefault();
        openZoom(page);
        return;
      }

      var opener = event.target.closest('[data-yip-open]');
      if (opener && root.contains(opener)) {
        var slug = opener.getAttribute('data-yip-open');
        if (!apply(slug)) return; // eşleşme yoksa tarayıcı normal gezinsin
        event.preventDefault();
        window.history.pushState({ ay: slug }, '', base + '?' + PARAM + '=' + encodeURIComponent(slug));
        window.scrollTo(0, 0);
        return;
      }

      var back = event.target.closest('[data-yip-back]');
      if (back && root.contains(back)) {
        event.preventDefault();
        apply(null);
        window.history.pushState({ ay: null }, '', base);
        window.scrollTo(0, 0);
      }
    });

    window.addEventListener('popstate', function () {
      /* Geri/ileri ile gezinirken açık kalan yakınlaştırma katmanı, artık
         görüntülenmeyen bir sayının görselini ekranda tutuyordu (üstelik
         body'de scroll kilidi de açık kalıyordu). Önce katmanı kapat. */
      closeZoom();
      apply(slugFromUrl());
    });

    // Satır içi (boyama öncesi) script ile aynı duruma hizala
    apply(slugFromUrl());
  }

  toArray(document.querySelectorAll('[data-yip-icindekiler]')).forEach(initRoot);

  // Tema düzenleyicisi blok eklendiğinde/çıkarıldığında bölümü yeniden basar;
  // yeni işaretlemenin dinleyicisiz kalmaması için tekrar kur.
  document.addEventListener('shopify:section:load', function (event) {
    toArray(event.target.querySelectorAll('[data-yip-icindekiler]')).forEach(initRoot);
  });
})();
